import { Activities } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction,
    linkedResourcesReducer, linkedResourcesAction
} = createRestSlices(Activities);

const START_CREATING_ITEM = 'kronos/activity/START_CREATING_ITEM';

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case START_CREATING_ITEM:
            return {
                ...state,
                activity: { is_exclusive: true }
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        linkedResourcesReducer, reducer
    ]);
}

/* Export CRUD actions */
export const resetActivity                = startCreateAction;
export const startCreateActivity          = startCreateAction;
export const createActivity               = createAction;
export const loadActivity                 = getAction;
export const loadActivities               = listAction;
export const updateActivity               = updateAction;
export const deleteActivity               = deleteAction;
export const duplicateActivity            = duplicateAction;
export const getActivitiesLinkedResources = linkedResourcesAction;
